var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e6e6bbfd-3e9f-4094-a95e-b50b24951a0c",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.2 273.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.eb8574cb-b821-4865-a655-9ca5297a3e3c{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.eb8574cb-b821-4865-a655-9ca5297a3e3c{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa7d9b50-91d8-4a2e-8697-b2f9abc890bc",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M250.38,6.55,209.14,30.4a4,4,0,0,0-2,3.46V78.29a4,4,0,0,1-2,3.47l-114,65.56a4,4,0,0,1-2,.53H51.83a4,4,0,0,0-2,.53l-37,21.31a4,4,0,0,0-2,3.46v93.44"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b0cdc2f9-a17d-4182-befb-77cbb33dcdc9",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M250.38,6.55,209.14,30.4a4,4,0,0,0-2,3.46V78.29a4,4,0,0,1-2,3.47l-114,65.56a4,4,0,0,1-2,.53H51.83a4,4,0,0,0-2,.53l-37,21.31a4,4,0,0,0-2,3.46v93.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eb8574cb-b821-4865-a655-9ca5297a3e3c",
    d: "M250.38,6.55,209.14,30.4a4,4,0,0,0-2,3.46V78.29a4,4,0,0,1-2,3.47l-114,65.56a4,4,0,0,1-2,.53H51.83a4,4,0,0,0-2,.53l-37,21.31a4,4,0,0,0-2,3.46v93.44"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.8459779b.svg";
export { ForwardRef as ReactComponent };